import { isBefore, isValid, parseISO } from "date-fns";

const FLU_SEASON_START_MONTH = 8; // September (0-indexed)
const PNEUMOCOCCAL_INTERVAL_YEARS = 5;

const toDate = (value) => {
  if (!value) return null;
  const date = parseISO(value);
  return isValid(date) ? date : null;
};

// Start of the current flu season (1 September of the current or previous year).
const currentFluSeasonStart = (now = new Date()) => {
  const seasonYear =
    now.getMonth() >= FLU_SEASON_START_MONTH
      ? now.getFullYear()
      : now.getFullYear() - 1;

  return new Date(seasonYear, FLU_SEASON_START_MONTH, 1);
};

// Influenza is overdue when there is no dose recorded in the current flu season.
export const isInfluenzaOverdue = (lastDoseDate, now = new Date()) => {
  const date = toDate(lastDoseDate);
  if (!date) return true;

  return isBefore(date, currentFluSeasonStart(now));
};

// Pneumococcal is overdue when the last dose is more than 5 years ago.
export const isPneumococcalOverdue = (lastDoseDate, now = new Date()) => {
  const date = toDate(lastDoseDate);
  if (!date) return true;

  const cutoff = new Date(now);
  cutoff.setFullYear(cutoff.getFullYear() - PNEUMOCOCCAL_INTERVAL_YEARS);

  return isBefore(date, cutoff);
};
